import { Tier } from './provider.types';

// ==================== FEATURED LIMITS CONFIGURATION ====================

export interface FeaturedLimits {
  /** Max featured countries (top-level coverage) */
  countries: number;
  /** Max featured trade directions per featured country */
  tradeDirectionsPerCountry: number;
  /** Max featured regions/states per featured country */
  regionsPerCountry: number;
  /** Max featured ports per featured country */
  portsPerCountry: number;
  /** Max featured routes */
  routes: number;
  /** Max featured services (isPrimary → isFeatured) */
  services: number;
  /** Max featured commodity groups */
  commodityGroups: number;
  /** Max featured shipment types */
  shipmentTypes: number;
}

// ==================== FEATURED USAGE ====================

export enum FeaturedCategory {
  countries = 'countries',
  tradeDirections = 'tradeDirections',
  regions = 'regions',
  ports = 'ports',
  routes = 'routes',
  services = 'services',
  commodityGroups = 'commodityGroups',
  shipmentTypes = 'shipmentTypes',
}

export interface FeaturedCategoryUsage {
  used: number;
  limit: number;
}

export interface FeaturedUsage {
  countries: FeaturedCategoryUsage;
  routes: FeaturedCategoryUsage;
  services: FeaturedCategoryUsage;
  commodityGroups: FeaturedCategoryUsage;
  shipmentTypes: FeaturedCategoryUsage;
}

export interface CountryFeaturedUsage {
  countryCoverageId: string;
  countryName: string;
  tradeDirections: FeaturedCategoryUsage;
  regions: FeaturedCategoryUsage;
  ports: FeaturedCategoryUsage;
}

// ==================== PROVIDER FEATURED STATUS DTO ====================

export interface ProviderFeaturedStatusDto {
  tier: Tier;
  /** Whether featured selections are currently active (tier supports featured) */
  isFeaturedActive: boolean;
  limits: FeaturedLimits;
  usage: FeaturedUsage;
  /** Per-country usage for trade directions and regions */
  countryUsage: CountryFeaturedUsage[];
}
